<router-outlet></router-outlet>

@if (showProgress) {
  <div class="overlay">
    <div class="overlay__inner">
      <div class="overlay__content">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    </div>
  </div>
}